const trimTrailingSlash = (value: string) => value.replace(/\/$/, "");

export const detectSimulatedMode = (): boolean => {
  if (typeof window !== "undefined") {
    const winFlag = (window as any)?.LAUNCHSAFELY_SIMULATED_MODE;
    if (typeof winFlag === "boolean") return winFlag;
    if (typeof winFlag === "string") {
      const lowered = winFlag.toLowerCase();
      if (lowered === "true") return true;
      if (lowered === "false") return false;
    }
  }
  const envFlag = process.env.REACT_APP_SIMULATED_MODE;
  return envFlag === "true";
};

export const resolveApiBase = (): string => {
  const envBase = process.env.REACT_APP_API_BASE_URL;
  if (envBase) return trimTrailingSlash(envBase);
  if (typeof window !== "undefined") {
    if (window.location.port === "3000") {
      return "http://localhost:5057";
    }
    return trimTrailingSlash(window.location.origin);
  }
  return "";
};
